import React, { useEffect, useRef } from "react";
import Button from "@/ui/Button/Button";
import Input from "@/ui/Input/Input";
import { useAdminPriceEdaContext } from "./context";
import cls from "./styles.module.scss";

export const EditorPopup = () => {
  const popupInputRef = useRef<HTMLInputElement | null>(null);

  const {
    selection: { selectedIds, selectedHexgroupId, selectedZoneId },
    editor: {
      edaTarget,
      draftPrice,
      setDraftPrice,
      popupOpen,
      closePopup,
      error,
      saving,
      zoneSaving,
      applyLocalPrice,
      createZone,
      updateZone,
      deleteZone,
    },
  } = useAdminPriceEdaContext();

  useEffect(() => {
    if (!popupOpen) return;

    const id = window.setTimeout(() => {
      popupInputRef.current?.focus();
      popupInputRef.current?.select();
    }, 0);

    return () => window.clearTimeout(id);
  }, [popupOpen, selectedIds.length]);

  if (!popupOpen) return null;

  return (
    <form
      className={cls.sidebarPopup}
      onSubmit={(e) => {
        e.preventDefault();
        applyLocalPrice();
      }}
    >
      <div className={cls.popupTitle}>
        {edaTarget === "eda_car"
          ? "Редактирование EDA авто"
          : "Редактирование EDA вело"}
      </div>
      <Input
        type="number"
        value={draftPrice}
        onChange={setDraftPrice}
        error={error}
        inputRef={popupInputRef}
      />
      <div className={cls.modalActions}>
        <Button
          type="button"
          label="Отмена"
          variant="outlined"
          onClick={closePopup}
          className={cls.sidebarActionButton}
        />
        <Button
          type="submit"
          label="Применить"
          onClick={() => null}
          loading={saving}
          disabled={!selectedIds.length}
          className={cls.sidebarActionButton}
        />
      </div>
      <div className={cls.zoneActions}>
        <Button
          type="button"
          label="Создать зону"
          variant="outlined"
          onClick={createZone}
          loading={zoneSaving}
          disabled={!selectedIds.length || selectedHexgroupId === null}
        />
        <Button
          type="button"
          label="Обновить зону"
          variant="outlined"
          onClick={updateZone}
          loading={zoneSaving}
          disabled={!selectedIds.length || selectedZoneId === null}
        />
        <Button
          type="button"
          label="Удалить зону"
          variant="danger"
          onClick={deleteZone}
          loading={zoneSaving}
          disabled={selectedZoneId === null}
          className={cls.zoneDeleteButton}
        />
      </div>
    </form>
  );
};
